export default __webpack_public_path__ + "static/media/img_sofa.a8fe3505.png";